module.exports = __webpack_public_path__ + "img/longquan5.65564284.png";